import React, { Component } from 'react'
import { runVerificaAutenticacao } from '../../services/api'
import '../../sass/app.scss'
import { user } from '../../helpers/user'

import { Header as HeaderUsage } from './Header'
import { HeaderCustomer } from './HeaderCustomer'

const isCustomer = !!user.codigo_vendedor

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      telas_usuarios: [],
      telas_liberadas: [],
      menupai: [],
      menufilho: [],
      codigo_usuario: '',
      nome_usuario: '',
      date: new Date(),
      view_menu_vendas: false,
      view_menu_status: false,
      view_menu_site: false,
      view_menu_relatorio: false,
      view_menu_produtividade: false,
    }
  }

  componentDidMount() {
    runVerificaAutenticacao()

    if (localStorage.getItem('authentication') != null) {
      this.configurePage()
      this.setState({
        codigo_usuario: JSON.parse(localStorage.getItem('authentication')).codigo_usuario,
        nome_usuario: JSON.parse(localStorage.getItem('authentication')).nome_usuario,
      })
    }
  }

  configurePage = async () => {
    try {
      var permissoes = JSON.parse(localStorage.getItem('authentication')).permissoes_usuario
      var telas = JSON.parse(localStorage.getItem('telascarregadas'))

      var telas_liberadas = []
      var menupai = []

      var menufilho = []
      for (var perm in permissoes) {
        telas_liberadas.push(telas[perm])

        if (!menupai.includes(telas[perm].nome_menu_pai)) {
          menupai.push(telas[perm].nome_menu_pai)
        }
        menufilho.push({
          menupai: telas[perm].nome_menu_pai,
          menufilho: telas[perm].nome_menu_filho,
          menulink: telas[perm].link_menu,
        })
      }

      menufilho.sort(function (a, b) {
        if (a.menufilho > b.menufilho) {
          return 1
        }
        if (a.menufilho < b.menufilho) {
          return -1
        }
        // a must be equal to b
        return 0
      })

      menupai.sort(function (a, b) {
        if (a > b) {
          return 1
        }
        if (a < b) {
          return -1
        }
        // a must be equal to b
        return 0
      })

      this.setState({
        codigo_usuario: JSON.parse(localStorage.getItem('authentication')).codigo_usuario,
        nome_usuario: JSON.parse(localStorage.getItem('authentication')).nome_usuario,
        avatarUrl: JSON.parse(localStorage.getItem('authentication')).foto_vendedor,
        permissoes_usuario: permissoes,
        telas_usuarios: telas,
        telas_liberadas: telas_liberadas,
        menupai: menupai,
        menufilho: menufilho,
      })
      this.setState({
        view_menu_vendas: !this.state.view_menu_vendas,
        view_menu_status: false,
        view_menu_site: false,
        view_menu_relatorio: false,
        view_menu_produtividade: false,
        view_menu_fac: false,
        view_menu_finacompras: false,
      })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  render() {
    const { telas_usuarios, telas_liberadas, menupai, menufilho } = this.state

    const control = {
      Vendas: this.state.view_menu_vendas,
      'Status do pedido': this.state.view_menu_status,
      Site: this.state.view_menu_site,
      Relatórios: this.state.view_menu_relatorio,
      Produtividade: this.state.view_menu_produtividade,
      FAQ: this.state.view_menu_fac,
      'Financeiro/Compras': this.state.view_menu_finacompras,
    }
    return (
      <>
        {!isCustomer && (
          <HeaderUsage
            menupai={this.state.menupai}
            menufilho={this.state.menufilho}
            nomeUsuario={this.state.nome_usuario}
            avatarUrl={this.state.avatarUrl}
          />
        )}

        {isCustomer && (
          <HeaderCustomer
            menupai={this.state.menupai}
            menufilho={this.state.menufilho}
            nomeUsuario={this.state.nome_usuario}
            avatarUrl={this.state.avatarUrl}
            {...this.props}
          />
        )}
      </>
    )
  }
}

export default Header
